import { AxiosRequestConfig } from 'axios';

export const noCacheOptions = {
    headers: {
        'Cache-Control': 'no-store,no-cache',
        Pragma: 'no-cache',
    },
} as AxiosRequestConfig;
